import React, {useEffect, useState} from 'react';
import {useStyles} from "./Checkbox.style";
import CheckboxProperties from "./CheckboxProperties";
import clsx from "clsx";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';


const Checkbox: React.FC<CheckboxProperties> = ({
                                                    className = '',
                                                    text,
                                                    onChange,
                                                    selected = false,
                                                    disabled = false,
                                                }) => {
    const classes = useStyles();
    const [checked, setChecked] = useState(selected);

    useEffect(() => {
        setChecked(selected);
    }, [selected])


    const onValueChange = () => {
        if (disabled) {
            return;
        }
        const newValue = !checked;
        setChecked(newValue);
        onChange(newValue);
    }

    return (
        <div className={clsx(classes.checkbox_container, className, disabled && classes.checkbox_disabled, !disabled && classes.checkbox_enabled)} onClick={onValueChange}>
            <div className={classes.icon_container}>
                {checked && <CheckBoxIcon/>}
                {!checked && <CheckBoxOutlineBlankIcon/>}
            </div>
            <div>{text}</div>
        </div>
    )
}
export default Checkbox;